<template>
  <div class="search-container">
    <div class="p-grid">
      <div class="p-col">
        <div class="p-input-icon-right search-input">
          <i
            class="pi pi-search"
            style="left: 0.5rem !important"
            v-if="!chips.length"
          />
          <i
            class="pi pi-angle-down"
            style="cursor: pointer"
            @click="$refs.searchFilters.toggle($event)"
          />
          <Chips
            type="text"
            style="width: 100%"
            :class="[
              {
                'search-input-placeholder-active': !chips.length,
              },
            ]"
            :placeholder="!chips.length ? 'Pesquisar' : ''"
            separator=","
            :modelValue="chips"
            @keyup.enter="search()"
            @add="addTerm($event)"
            @remove="removeChip($event)"
          />

          <div id="search-options" style="width: 95%"></div>

          <SearchContainer
            v-if="isMounted"
            ref="searchFilters"
            v-slot:default="{ isPanel }"
          >
            <div
              class="p-fluid search-options-fields"
              :style="
                optionsHeight && isPanel
                  ? { maxHeight: optionsHeight, paddingRight: '10px' }
                  : {}
              "
            >
              <!-- Nome do comprador -->
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span
                    class="material-icons search-option-icon p-mr-3"
                    style="font-size: 20px"
                  >
                    person
                  </span>
                  Comprador
                </label>
                <div class="p-col-8">
                  <InputText v-model="searchFilters.buyerName.value" />
                </div>
              </div>
              <!-- Data -->
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    event
                  </span>
                  Data entre
                </label>
                <div class="p-col-4">
                  <Calendar
                    v-model="searchFilters.date.value[0]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="dateRange"
                    :locale="$locales.calendar.ptBR"
                    appendTo="body"
                  />
                </div>
                <div class="p-col-4">
                  <Calendar
                    v-model="searchFilters.date.value[1]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="dateRange"
                    :locale="$locales.calendar.ptBR"
                    appendTo="body"
                  />
                </div>
              </div>
              <!-- Valor -->
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span
                    class="material-icons search-option-icon p-mr-3"
                    style="font-size: 22px"
                  >
                    attach_money
                  </span>
                  Valor entre
                </label>
                <div class="p-col-4">
                  <InputNumber
                    v-model="searchFilters.totalValue.value[0]"
                    :minFractionDigits="2"
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                  />
                </div>
                <div class="p-col-4">
                  <InputNumber
                    v-model="searchFilters.totalValue.value[1]"
                    :minFractionDigits="2"
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                  />
                </div>
              </div>
              <!-- Peso -->
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="search-option-icon p-mr-3">
                    <IconWeight
                      style="margin-top: 5px"
                      :width="18"
                      :height="15"
                    ></IconWeight>
                  </span>
                  Peso entre
                </label>
                <div class="p-col-4">
                  <InputNumber
                    v-model="searchFilters.totalWeight.value[0]"
                    mode="decimal"
                    locale="pt-BR"
                    :minFractionDigits="2"
                  />
                </div>
                <div class="p-col-4">
                  <InputNumber
                    v-model="searchFilters.totalWeight.value[1]"
                    mode="decimal"
                    locale="pt-BR"
                    :minFractionDigits="2"
                  />
                </div>
              </div>
            </div>

            <div class="p-fluid" style="margin-top: 20px">
              <div class="p-grid p-jc-end">
                <div class="p-col-4">
                  <Button label="Pesquisar" @click="search()" />
                </div>
              </div>
            </div>
          </SearchContainer>
        </div>
      </div>
      <div class="p-col-3">
        <Dropdown
          v-model="searchOrder.orderField"
          :options="searchOrder.options"
          optionLabel="name"
          placeholder="Ordenar por"
          @change="search()"
          style="width: 100%"
        />
      </div>
      <div class="p-col-fixed search-order" style="width: 50px">
        <Button
          :icon="orderIcon"
          class="p-button-text p-button-plain"
          @click="changeOrder()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';
import IconWeight from '../../../components/icon/IconWeight.vue';
import { useTermFilter } from '../../../lib/bovineSearch';
import {
  buildQuery,
  useTextFilter,
  useDateRangeFilter,
  useValueRangeFilter,
} from '../../../lib/search';
import SearchContainer from '../../../components/SearchContainer.vue';

export default {
  name: 'BovineSearch',
  components: {
    IconWeight,
    SearchContainer,
  },
  props: {
    optionsHeight: {
      type: [Number, String],
      default: () => '70vh',
    },
  },
  data() {
    return {
      dateRange: `${this.$dayjs()
        .subtract(10, 'y')
        .format('YYYY')}:${this.$dayjs().add(10, 'y').format('YYYY')}`,
      chips: [],
      searchFilters: {
        term: useTermFilter(),
        buyerName: useTextFilter('Comprador', 'buyerName'),
        date: useDateRangeFilter('Data', 'date'),
        totalWeight: useValueRangeFilter('Peso', 'totalWeight'),
        totalValue: useValueRangeFilter('Valor', 'totalValue'),
      },
      searchOrder: {
        orderField: null,
        order: '',
        options: [
          { name: 'Data', value: 'date' },
          { name: 'Peso', value: 'totalWeight' },
          { name: 'Valor', value: 'totalValue' },
          { name: 'Comprador', value: 'buyer.name' },
        ],
      },
      isMounted: false,
    };
  },
  async created() {
    const { chips } = this.buildQuery();
    this.chips = chips;
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    orderIcon() {
      if (!this.searchOrder.order) {
        return 'pi pi-sort-alt';
      }
      return this.searchOrder.order === 'asc'
        ? 'pi pi-sort-amount-up'
        : 'pi pi-sort-amount-down';
    },
  },
  methods: {
    addTerm({ value }) {
      const term = value
        .filter((v) => !v.includes(':') || v.includes('Termo: '))
        .map((v) => v.replace('Termo: ', ''));
      this.searchFilters.term.value = term;
    },
    removeChip(event) {
      const [name, value] = event.value[0].split(': ');
      const field = Object.keys(this.searchFilters).find(
        (key) => this.searchFilters?.[key]?.name === name
      );
      const searchFilter = this.searchFilters[field];
      if (searchFilter.removeValue) {
        this.searchFilters[field].value = searchFilter.removeValue(
          searchFilter.value,
          value
        );
      }
      this.search();
    },
    changeOrder() {
      this.searchOrder.order =
        this.searchOrder.order === 'asc' ? 'desc' : 'asc';
      this.search();
    },
    buildQuery() {
      return buildQuery(this.searchFilters, this.searchOrder);
    },
    search: debounce(
      function search() {
        const { query, chips } = this.buildQuery();
        this.chips = chips;
        this.$emit('search', { query });
        this.$refs.searchFilters.hide();
      },
      500,
      true
    ),
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  ::v-deep .p-overlaypanel {
    left: 0 !important;
  }
  ::v-deep .p-overlaypanel:after,
  .p-overlaypanel:before {
    left: calc(var(--overlayArrowLeft, 0) + 0.6rem);
  }
  ::v-deep .p-overlaypanel:before {
    left: calc(var(--overlayArrowLeft, 0) + 0.6rem);
  }
}
.search-option-icon {
  font-size: 18px;
  color: #495057;
}
.search-options-fields {
  overflow-y: auto;
  overflow-x: hidden;
}
.search-input {
  width: 100%;
  ::v-deep .p-chips-multiple-container {
    width: 100%;
    display: inline;
  }
}
.search-input-placeholder-active {
  ::v-deep input {
    padding-left: 1.5rem !important;
  }
}
.search-order {
  button {
    background-color: white;
  }
}
.search-order .p-button {
  border: 1px solid #ced4da !important;
  border-radius: 3px !important;
}
@media (max-width: 600px) {
  .search-container .p-col {
    flex-grow: unset !important;
    flex-basis: unset !important;
    width: 100%;
  }
  .search-container .p-col-3 {
    flex-grow: 1;
    flex-basis: 0;
  }
  .search-order {
    width: 47px !important;
  }
}
</style>
